import React from 'react'
import background from '../images/bg.jpeg';

const BottomSwiper = () => {
  
    return (
        <div className='rounded-b-full  pb-16 shadow-2xl bg-black' ></div>
    )
}

export default BottomSwiper 